import { render } from "./CardSettings.vue?vue&type=template&id=77f420ff"
const script = {}

import exportComponent from "D:\\fclinique\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__